import { AbstractPmsApiService } from "./abstract.service";
/**
 * @class PropertyRoomsPmsApiService
 * @abstract
 * @extends {PropertyRoomsPmsApiService<Property>}
 */
export class PropertyRoomsPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/rooms';
    }
    
    /**
     * @param {Object} attributes
     * @return {Object}
     */
    newModel(attributes) {
        
        return attributes;
    }
    
    /**
     * @param {Property} property
     * @returns {Promise.<PaginationCollection<Property>>}
     */
    get (property) {
        
        const url = this.url({propertyId: property.id});
        return this.http
                   .get(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
}


// WEBPACK FOOTER //
// ./src/pms-api/services/property-room.service.js